import { Component, Input, OnChanges } from "@angular/core"

@Component({
    selector: "app-language-badge",
    templateUrl: "./language-badge.component.html",
    styleUrls: ["./language-badge.component.scss"],
    standalone: false,
})
export class LanguageBadgeComponent implements OnChanges {
    @Input() public languages: string[]

    public displayText: string
    public displayLanguage: string

    public updateDisplayText() {
        this.displayLanguage = ""
        this.displayText = ""
        if (this.languages && this.languages.includes("Spanish")) {
            this.displayLanguage = "ES"
            if (this.languages.length == 1) {
                this.displayText = " "
            } else {
                this.displayText = "Also in "
            }
        }
    }

    public ngOnChanges() {
        this.updateDisplayText()
    }
}
